import { addContractField } from './Contract';
/**
 * Get fields for a 'custom' contract that doesn't ship with OTel.js
 * You pass in the parameters for a contract, and this function returns the data fields in TelemetryEvent.dataFields format.
 * @param instanceName - The instance of the contract. Usually the same as the contract name without its namespace,
 *                       but can be different, especially if you have more than one of the same contract type in a single event.
 * @param contractName - The name of the contract, for example Office.System.SDX
 * @param contractFields - The data fields in the contract.
 */
export function getFieldsForContract(instanceName, contractName, contractFields) {
    var dataFields = contractFields.map(function (contractField) {
        return {
            name: instanceName + "." + contractField.name,
            value: contractField.value,
            dataType: contractField.dataType
        };
    });
    addContractField(dataFields, instanceName, contractName);
    return dataFields;
}
//# sourceMappingURL=CustomContract.js.map